module.exports = __webpack_public_path__ + "static/media/AvenirNext.1b5dd6ff.svg";